export enum DeclineReason {
    Declined = 'DECLINED',
    ExceptionRequested = 'EXCEPTION_REQUESTED',
    Missing = 'MISSING',
    NotRenewed = 'NOT_RENEWED',
}
